/**
 * Model to keep state in the discoverability section on the Product Edit page.
 */

var ShapewaysModel = require('./ShapewaysModel');
var $ = require('js/sw-jquery/sw-jquery');
var actions = require('js/lib/actions/ProductDiscoverability/actionTypes');
var actionCreators = require('js/lib/actions/ProductDiscoverability/actionCreators');
var productEditActionCreators = require('js/lib/actions/ProductEditModel/actionCreators');
var sw = require('js/lib/sw');

var MESSAGE_TIMEOUT = 5000;

var ProductDiscoverabilityModel = ShapewaysModel.extend({
  idAttribute: 'spin',
  pluralName:  'productDiscoverabilityModels',

  actions: {
    'categoryChanged':       actions.CATEGORY_CHANGED,
    'variantChanged':        actions.VARIANT_CHANGED,
    'tagsChanged':           actions.TAGS_CHANGED
  },

  defaults: {
    facets: {},
    chosenCategory: null,
    selectedVariantId: null,
    contentLicenseTags: []
  },

  /**
   * Returns action creators.
   * @returns {*}
   */
  getActionCreators: function getActionCreators() {
    return actionCreators;
  },

  /**
   * Requests new facet groups on category change.
   *
   * @param state object Application state
   * @param action object
   */
  categoryChanged: function(state, action) {
    var that = this;

    $.swAjax({
      url: '/product/facets',
      data: {
        categoryId: action.payload.categoryId
      },
      dataType: 'json',
      success: function(response) {
        if (response.facets) {
          that.set('facets', response.facets);
        }
      },
      error: function(jqXHR) {
        if (jqXHR.responseText) {
          sw.notifications.error(jqXHR.responseText, {timeout: MESSAGE_TIMEOUT});
        }
      }
    });
  },

  /**
   * Updates the status of whether a variant choice has been selected/deselected.
   *
   * @param state
   * @param action
   */
  variantChanged: function(state, action) {
    this.set('selectedVariantId', action.payload.variantSelected);
  },

  /**
   * Updates state and dispatches change to ProductEditModel.
   *
   * @param state obj Current state.
   * @param action obj Action type and payload.
   */
  tagsChanged: function(state, action) {
    sw.dispatch(productEditActionCreators.contentLicenseTagEntered(action.payload.licenseId));
  }
});

module.exports = ProductDiscoverabilityModel;
